export default "__VITE_ASSET__CKVfLS$M__"